import { createFileRoute } from '@tanstack/react-router'
import HomePage from '@/components/pages/HomePage/HomePage'

export const Route = createFileRoute('/home')({
  component: HomeRoute,
})

function HomeRoute() {
  return <HomePage />
}
